import { render, staticRenderFns } from "./ConversationCard.vue?vue&type=template&id=528a3d37&scoped=true&"
import script from "./ConversationCard.vue?vue&type=script&lang=js&"
export * from "./ConversationCard.vue?vue&type=script&lang=js&"
import style0 from "./ConversationCard.vue?vue&type=style&index=0&id=528a3d37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528a3d37",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('528a3d37')) {
      api.createRecord('528a3d37', component.options)
    } else {
      api.reload('528a3d37', component.options)
    }
    module.hot.accept("./ConversationCard.vue?vue&type=template&id=528a3d37&scoped=true&", function () {
      api.rerender('528a3d37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/ConversationCard.vue"
export default component.exports